import * as React from 'react';

import CareerOutcomesModule from 'bundles/unified-description-page-common/components/modules/career-outcomes/CareerOutcomesModule';
import DataBox from 'bundles/unified-description-page-common/components/modules/career-outcomes/DataBox';
import PAGE_TYPES from 'bundles/unified-description-page-common/constants/pageTypes';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import {
  getCareerOutcomesTitleForProject,
  getCareerOutcomesValuePropsForGuidedProject,
  getCareerOutcomesValuePropsForProject,
} from 'bundles/unified-description-page-common/utils/careerOutcomes';
import { PROJECT_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

import careerOutcomesDataBoxImage from 'images/unified-description-page/career-outcomes-project.png';

const CareerOutcomesModuleRenderer = () => {
  const { pageType } = usePageInfo();

  const valueProps =
    pageType === PAGE_TYPES.GUIDED_PROJECT
      ? getCareerOutcomesValuePropsForGuidedProject()
      : getCareerOutcomesValuePropsForProject();

  return (
    <CareerOutcomesModule
      anchorId={PROJECT_NAV_ITEMS.OUTCOMES}
      title={getCareerOutcomesTitleForProject()}
      valueProps={valueProps}
      dataBox={<DataBox imageSrc={careerOutcomesDataBoxImage} />}
    />
  );
};

export default CareerOutcomesModuleRenderer;
